import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from '../locales/en/translation.json'
import id from '../locales/id/translation.json'
import zh from '../locales/zh/translation.json'

i18n.use(LanguageDetector).init({
    compatibilityJSON: 'v3',
    detection: {
        order: ['localStorage', 'navigator'], // detect browser language
    },
    resources: {
        en: { translation: en },
        id: { translation: id },
        zh: { translation: zh },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
        useSuspense: false,
    },
})

export default i18n
